import { useState, useEffect } from 'react';
import apiService from '../services/apiService'; // Centralized API service

const usePayments = (currentPage = 1, currentPageLimit = 100, refreshKey, period = null, startDate = '', endDate = '') => {
  const [payments, setPayments] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPageLimit, setTotalPagesLimit] = useState(10);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPayments = async () => {
      setLoading(true);
      try {
        const response = await apiService.getPayments(currentPage, currentPageLimit, period, startDate, endDate);
        const { items, total_pages, limit } = response;
        setPayments(items);
        setTotalPages(total_pages);
        setTotalPagesLimit(limit);
        setError(null);
      } catch (err) {
        console.error(err);
        setError(err.message || 'Error fetching payments');
      } finally {
        setLoading(false);
      }
    };
    fetchPayments();
  }, [currentPage, currentPageLimit, refreshKey, period, startDate, endDate]);

  return { payments, totalPages, totalPageLimit, loading, error };
};

export default usePayments;
